/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Joi from 'joi-browser';

import withStyles from '@material-ui/core/styles/withStyles';
import Search from '@material-ui/icons/Search';

import Form from './Form';
import { form as FormStyle } from '../style/form';
// import EventDispatcher from '../../state/reducers/EventDispatcher';

import configEnv from '../config';

const { PERSIST_KEY } = configEnv;

const styles = ({ typography, palette }) => FormStyle(typography, palette);

class SearchInput extends Form {
    state = {
        data: {
            search: '',
        },
        errors: {},
    };

    schema = {
        search: Joi.any().optional(),
    };

    render() {
        // eslint-disable-next-line object-curly-newline
        const { classes, label, onChange, className } = this.props;
        return (
            <>
                <form className={`${classes.form} ${className}`}>
                    {this.renderInput({
                        name: 'search',
                        label,
                        type: 'search',
                        length: 25,
                        adornment: <Search />,
                        adornmentPosition: 'icon-start',
                        onChangeHandler: onChange,
                    })}
                </form>
            </>
        );
    }
}

SearchInput.defaultProps = {
    className: '',
};

SearchInput.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isReadyState: newState.isReadyState,
    };
};

export default connect(
    mapStateToProps,
    null,
)(withStyles(styles)(SearchInput));
